import { httpClient } from '@/services/http/httpClient'

import type { FileType } from '@/types/fileType'

type Params = {
  name?: string
  slogan?: string
  logo?: FileType
  bigLogo?: FileType
}

export async function changeAppearance({
  name,
  slogan,
  logo,
  bigLogo,
}: Params) {
  const payload = new FormData()

  payload.append('name', name ?? '')
  payload.append('slogan', slogan ?? '')

  const logoFile = logo?.file
  if (logoFile) {
    payload.append('slogan_mini', logoFile)
  }

  const bigLogoFile = bigLogo?.file
  if (bigLogoFile) {
    payload.append('slogan_big', bigLogoFile)
  }

  await httpClient.post('/tennants/configs/appearance', payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
